import { mapGetters, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('UserDisplayPreferencesModule', {
      displaySettings: state => state.displayPreferencesData,
    }),

    ...mapGetters('OrganizationsCollection', {
      orgIsOlderThanDays: 'getOrgIsOlderThanDays',
    }),

    fundamentalsWidgetVisibility() {
      return this.displaySettings.display.fundamentals.visible;
    },

    orgCreatedUnderThirtyDaysAgo() {
      return !this.orgIsOlderThanDays(30);
    },
  },
};
